import React, { useState, useRef, useEffect } from "react";

//Importar helpers. 
import { onfileSelected } from "../../../../../helpers/multimedia/onfileSelected.js";
import { verifyCondition_writeMessage } from "../../../../../const/conditionalConstants/writeMessageRender.js";

//Importar componentes locales.
import MenuSelectFileType from "../Menu/MenuSelectFileType.jsx";
import BtnSendMessage from "./BtnSendMessage.jsx";

//Importar íconos de Material UI.
import { InsertEmoticon, AttachFile } from '@mui/icons-material/';
import EmojiPicker from "emoji-picker-react";
import useClickOutside from "../../../../../hooks/useClickOutside.js";

// WriteMessage: Componenete que renderiza el campo para escribir un mensaje dentro del Chat.

const WriteMessage = ({ sessionSelected, setTypeFile, setFilesSelected, socketConnected, filesSelected, sessionsChatSelected, setOpenMessageFileSize }) => {
    const [mensaje, setMensaje] = useState('');  //Estado para actualizar el mensaje a enviarse.
    const [openEmoji, setOpenEmoji] = useState(false); //Estado para abrir y cerrar el menú de emoticones.
    const [openMenuNewFile, setOpenMenuNewFile] = useState(false); //Estado para abrir y cerrar el menu de seleccionar el tipo de archvio multimedia.
    const [keyDownSendMessage, setKeyDownSendMessage] = useState(""); //Estado para ejecutar el useEffect dentro del botón de enviar mensaje.

    const textareaRef = useRef(null); 
    const sendFileRef = useRef(null); // Referencia para el botón de agregar un nuevo archivo.
    const emojiRef = useRef(null); // Referencia para el botón de agregar un emoji.
    const containerRef = useRef(null);

    //Función para agregar un emoji al mensaje existente.
    const handleEmojiSelected = (emoji) => setMensaje(prevMensaje => prevMensaje + emoji);

    // Verificar la condición para renderizar el campo para escribir el mensaje de texto.
    let WRITE_MESSAGE_CONDITION = verifyCondition_writeMessage(sessionSelected, socketConnected, filesSelected, sessionsChatSelected);
    
    const onSelectedFile = (fileSelect) => { //Función de callback que actualiza el valor del file seleccionado.
        onfileSelected(fileSelect, filesSelected, setFilesSelected, setOpenMessageFileSize);
        setOpenMenuNewFile(false); //Cerrar el Menú para seleccionar el archivo.
    };

    const handleKeyDown = (e) => { //Función para enviar un mensaje al presionar enter en el campo para escribir.
        console.log("esto es el kewDown", e)
        if (e.key === 'Enter' && !e.shiftKey) { //Si los eventos del teclado no incluyen el Enter + Shift
            e.preventDefault();
            setKeyDownSendMessage("enviar"); //Actualiza el estado a "enviar" el mensaje.
        }
    };

    const handleInput = (e) => {
        setMensaje(e.target.value);
        adjustTextareaHeight();
    };
    
    const adjustTextareaHeight = () => {
        if(textareaRef){

            const textarea = textareaRef.current;
            const container = containerRef.current;
            console.log("se envió un mensaje",textareaRef.current,  textarea.style.height, textarea.style.height);
            textarea.style.height = "auto"; 
            textarea.style.height = `${textarea.scrollHeight}px`;
    
            const maxHeight = 200;
            if (textarea.scrollHeight > maxHeight) {
                textarea.style.height = `${maxHeight}px`;
                textarea.style.overflowY = "scroll";
            } else {
                textarea.style.overflowY = "hidden";
            }
    
            container.style.height = `${textarea.scrollHeight + 13}px`; // Ajusta el tamaño del contenedor también
        };
        }
    useEffect(() => {
        if (textareaRef.current){
            console.log("voy a ejecutar el adjustTextAreaheight", textareaRef)
            adjustTextareaHeight();
        }
    }, [mensaje]);

    useClickOutside(emojiRef, () => setOpenEmoji(false));

    return (
        <>
            {WRITE_MESSAGE_CONDITION &&
                <div className="container-chat__textArea" ref={containerRef}>
    
                    {/*------Botones para adjuntar un archivo y añadir íconos-------*/}
                    <div className="container-chat__actions" >
                        <InsertEmoticon sx={{ fontSize: '25px' }} className="chat-actions__icon" 
                        onClick={() => setOpenEmoji(!openEmoji)} ref={emojiRef} />

                        <AttachFile sx={{ fontSize: '25px' }} className="chat-actions__icon"
                         ref={sendFileRef} onClick={() => setOpenMenuNewFile(!openMenuNewFile)} />
                    </div>
                    <textarea  ref={textareaRef} onChange={handleInput} value={mensaje} onKeyDown={handleKeyDown} placeholder="Escribe tu mensaje..."
                        rows="1" />

                    <BtnSendMessage setMensaje={setMensaje} type="text" mensaje={mensaje} keyDownSendMessage={keyDownSendMessage}
                        setKeyDownSendMessage={setKeyDownSendMessage} sessionSelected={sessionSelected} />
                </div>
            }

            {/*-------Contenedor con el menú de emojis---------- */}
            {openEmoji && <div className="container-chat__emojis" > 
                <EmojiPicker  searchDisabled  theme="dark" style={{ background: "var(--bg-color-by-mode)", border: "none"}} 
                onEmojiClick={(emoji) => handleEmojiSelected(emoji.emoji)} />
            </div>}

            {/*----Contenedor del Menú desplegable para subir un archivo----*/}
            {openMenuNewFile && <MenuSelectFileType setTypeFile={setTypeFile} onSelectedFile={onSelectedFile} clickRef={sendFileRef} setOpenMenuFiles={setOpenMenuNewFile} />}

        </>
    )
};

export default WriteMessage;